import { combineReducers } from "redux"
import alert from "./alert/alertReducer"

export default combineReducers({
  alert,
})
